/**
 * i18n.js
 * Internationalization configuration for NPO CDE LAB
 * 
 * Supports Japanese (default) and English translations
 * with automatic language detection and smooth transitions
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationJA from './locales/ja.json';
import translationEN from './locales/en.json';

// Translation resources
const resources = {
  ja: {
    translation: translationJA
  },
  en: {
    translation: translationEN
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'ja', // Default language (Japanese)
    lng: localStorage.getItem('language') || 'ja', // Use stored language or default to Japanese
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    // Enable debug mode in development
    debug: process.env.NODE_ENV === 'development',
    
    // React-specific options
    react: {
      useSuspense: false // Disable suspense to avoid loading state
    }
  });

// Save language preference when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  document.documentElement.lang = lng; // Update HTML lang attribute
});

export default i18n;
